import { AMAZON } from '@/constants/amazon'
import Vue from 'vue'

Vue.prototype.$session = new Vue({
  data: {
    [AMAZON.ACCESS_TOKEN_015]: localStorage.getItem(AMAZON.ACCESS_TOKEN_015),
    [AMAZON.ACCESS_TOKEN_029]: localStorage.getItem(AMAZON.ACCESS_TOKEN_029),
    [AMAZON.CART_LINE029]: localStorage.getItem(AMAZON.CART_LINE029),
    [AMAZON.CART_LINE004]: localStorage.getItem(AMAZON.CART_LINE004),
    [AMAZON.BACKUP_AMAPAY_015]: localStorage.getItem(AMAZON.BACKUP_AMAPAY_015),
    [AMAZON.BACKUP_AMAPAY_029]: localStorage.getItem(AMAZON.BACKUP_AMAPAY_029),
    [AMAZON.CART_LINE015]: localStorage.getItem(AMAZON.CART_LINE015),
    [AMAZON.CART_LINE028]: localStorage.getItem(AMAZON.CART_LINE028),
    [AMAZON.SHIPPING_FEE]: localStorage.getItem(AMAZON.SHIPPING_FEE),
  },
  watch: {
    [AMAZON.ACCESS_TOKEN_015](value) {
      if (value) {
        localStorage.setItem(AMAZON.ACCESS_TOKEN_015, value)
      } else {
        localStorage.removeItem(AMAZON.ACCESS_TOKEN_015)
      }
    },
    [AMAZON.ACCESS_TOKEN_029](value) {
      if (value) {
        localStorage.setItem(AMAZON.ACCESS_TOKEN_029, value)
      } else {
        localStorage.removeItem(AMAZON.ACCESS_TOKEN_029)
      }
    },
    [AMAZON.CART_LINE029](value) {
      if (value) {
        localStorage.setItem(AMAZON.CART_LINE029, value)
      } else {
        localStorage.removeItem(AMAZON.CART_LINE029)
      }
    },
    [AMAZON.CART_LINE004](value) {
      if (value) {
        localStorage.setItem(AMAZON.CART_LINE004, value)
      } else {
        localStorage.removeItem(AMAZON.CART_LINE004)
      }
    },
    [AMAZON.BACKUP_AMAPAY_015](value) {
      if (value) {
        localStorage.setItem(AMAZON.BACKUP_AMAPAY_015, value)
      } else {
        localStorage.removeItem(AMAZON.BACKUP_AMAPAY_015)
      }
    },
    [AMAZON.BACKUP_AMAPAY_029](value) {
      if (value) {
        localStorage.setItem(AMAZON.BACKUP_AMAPAY_029, value)
      } else {
        localStorage.removeItem(AMAZON.BACKUP_AMAPAY_029)
      }
    },
    [AMAZON.CART_LINE015](value) {
      if (value) {
        localStorage.setItem(AMAZON.CART_LINE015, value)
      } else {
        localStorage.removeItem(AMAZON.CART_LINE015)
      }
    },
    [AMAZON.CART_LINE028](value) {
      if (value) {
        localStorage.setItem(AMAZON.CART_LINE028, value)
      } else {
        localStorage.removeItem(AMAZON.CART_LINE028)
      }
    },
    [AMAZON.SHIPPING_FEE](value) {
      if (value) {
        localStorage.setItem(AMAZON.SHIPPING_FEE, value)
      } else {
        localStorage.removeItem(AMAZON.SHIPPING_FEE)
      }
    },
  },
})
